import {
  GetLiderClubes,
  GetLiderReporte
} from "../../../reducers/comisionMembresia";
import * as actions from "../../../actions/comisionMembresia";
import { Preview } from "../../../../types/IAction";

export interface ReporteLiderDispatcher {
  getClubesByLider: (
    periodo: string,
    idLider?: number
  ) => Promise<Preview<GetLiderClubes>>;
  getReporteByLiderClub: (
    periodo: string,
    idClub: number,
    idLider?: number
  ) => Promise<Preview<GetLiderReporte>>;
}

export const reporteLiderDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReporteLiderDispatcher = dispatch => ({
  getClubesByLider: (periodo: string, idLider?: number) => {
    return dispatch(actions.getClubesByLider(periodo, idLider));
  },
  getReporteByLiderClub: (
    periodo: string,
    idClub: number,
    idLider?: number
  ) => {
    return dispatch(actions.getReporteByLiderClub(periodo, idClub, idLider));
  }
});
